//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class ParentSignupInputItem extends ItemBase {
    Address: string | null = null;
    EmailAddress: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    Referrer: string | null = null;
    TelephoneNumberHome: string | null = null;
    TelephoneNumberMobile: string | null = null;

    constructor(initializer?: Partial<ParentSignupInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ParentSignupInputItem";
}
